export type LoginFormProps = Partial<Common.Props>

export enum LoginFormField {
  Username = 'username',
  Password = 'password',
  Confirm = 'confirm',
  GivenName = 'givenName',
  Surname = 'surname'
}
